import { Button, CircularProgress, Grid } from '@mui/material';
import PropTypes from 'prop-types';

export default function WizardButtons({
  nextStep,
  previousStep,
  loading,
  disabled,
  nextLabelButtonType,
}) {
  return (
    <Grid container justifyContent="space-between" marginTop={2}>
      <Grid item>
        {previousStep && (
          <Button variant="outlined" onClick={previousStep} disabled={loading}>
            Previous
          </Button>
        )}
      </Grid>
      <Grid item>
        {nextStep && (
          <Button
            variant="contained"
            type={nextLabelButtonType}
            onClick={nextLabelButtonType === 'submit' ? undefined : nextStep}
            disabled={loading || disabled}
            sx={{
              bgcolor: '#EE7B57',
              '&:hover': {
                bgcolor: '#d66a47',
              },
            }}>
            {loading ? <CircularProgress size={24} /> : 'Next'}
          </Button>
        )}
      </Grid>
    </Grid>
  );
}

WizardButtons.propTypes = {
  nextStep: PropTypes.func,
  previousStep: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  nextLabelButtonType: PropTypes.string,
};

WizardButtons.defaultProps = {
  nextStep: null,
  previousStep: null,
  loading: false,
  disabled: false,
  nextLabelButtonType: 'button',
};
